import * as React             from 'react';
import PropTypes              from 'prop-types';
import CheckboxGroupComponent from './checkbox-group-component';

export default class CheckboxGroupContainer extends React.Component {
	render() {
		return <CheckboxGroupComponent {...this.props} />
	}
}


// WEBPACK FOOTER //
// ./src/component/form/checkbox-group/checkbox-group-container.js